import { UserRole, type User } from "../types/User";

export const normalizeUserRole = (value: unknown): UserRole => {
    if (typeof value !== "string") return UserRole.USER;

    const normalized = value.trim().toLowerCase();
    if (normalized === "superadmin" || normalized === "super admin" || normalized === "super_admin") {
        return UserRole.SUPER_ADMIN;
    }

    if (normalized === "admin") {
        return UserRole.ADMIN;
    }

    return UserRole.USER;
};

export const isRegularUserRole = (value: unknown): boolean =>
    normalizeUserRole(value) === UserRole.USER;

export const isTenantAdminRole = (value: unknown): boolean =>
    normalizeUserRole(value) === UserRole.ADMIN;

export const isSuperAdminRole = (value: unknown): boolean =>
    normalizeUserRole(value) === UserRole.SUPER_ADMIN;

export const hasTenantWideAccess = (value: unknown): boolean => {
    const role = normalizeUserRole(value);
    return role === UserRole.ADMIN || role === UserRole.SUPER_ADMIN;
};

export const isRegularUser = (user: Pick<User, "role"> | null | undefined): boolean =>
    isRegularUserRole(user?.role);
